import { render } from "./shareWorkshopsTask.vue?vue&type=template&id=491885eb&scoped=true"
import script from "./shareWorkshopsTask.vue?vue&type=script&lang=js"
export * from "./shareWorkshopsTask.vue?vue&type=script&lang=js"

import "./shareWorkshopsTask.vue?vue&type=style&index=0&id=491885eb&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491885eb"]])

export default __exports__